import { extendTheme } from "@chakra-ui/react"
import overrides from "/src/theme"

const customTheme = extendTheme(overrides)

//console.log(customTheme)
export default customTheme
